module.exports = __webpack_public_path__ + "img/google-play-badge.235818b9.png";